var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEventIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 20,
    viewBox: "0 0 27 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2544 13.1621C15.1874 13.1621 16.7544 11.5951 16.7544 9.66211C16.7544 7.72911 15.1874 6.16211 13.2544 6.16211C11.3214 6.16211 9.75439 7.72911 9.75439 9.66211C9.75439 11.5951 11.3214 13.1621 13.2544 13.1621Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.68603 15.2307C6.95397 14.4999 6.37319 13.6319 5.97693 12.6764C5.58067 11.7209 5.37671 10.6966 5.37671 9.66222C5.37671 8.62781 5.58067 7.60355 5.97693 6.64805C6.37319 5.69255 6.95397 4.82456 7.68603 4.09375",
    stroke: "white",
    strokeOpacity: 0.35,
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8228 4.09375C19.5548 4.82456 20.1356 5.69255 20.5319 6.64805C20.9281 7.60355 21.1321 8.62781 21.1321 9.66222C21.1321 10.6966 20.9281 11.7209 20.5319 12.6764C20.1356 13.6319 19.5548 14.4999 18.8228 15.2307",
    stroke: "white",
    strokeOpacity: 0.35,
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.59228 18.3241C3.45351 17.1873 2.55008 15.8371 1.93368 14.3508C1.31728 12.8644 1 11.2711 1 9.66206C1 8.05298 1.31728 6.45969 1.93368 4.97336C2.55008 3.48702 3.45351 2.13682 4.59228 1",
    stroke: "white",
    strokeOpacity: 0.35,
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9165 1C23.0553 2.13682 23.9587 3.48702 24.5751 4.97336C25.1915 6.45969 25.5088 8.05298 25.5088 9.66206C25.5088 11.2711 25.1915 12.8644 24.5751 14.3508C23.9587 15.8371 23.0553 17.1873 21.9165 18.3241",
    stroke: "white",
    strokeOpacity: 0.35,
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventIcon);
export default __webpack_public_path__ + "static/media/event-icon.679040a99eba14199ae83ef6a3e0f9ef.svg";
export { ForwardRef as ReactComponent };